<template>
  <div>
    <v-navigation-drawer
      v-model="show"
      app
      :mini-variant.sync="mini"
      permanent
      :disable-route-watcher="true"
      :disable-resize-watcher="true"
      @transitionend="transitionend"
      @update:mini-variant="onUpdate"
      >
      <v-list-item class="px-2">
        <v-list-item-avatar @click.stop="mini = !mini">
          <!-- <v-img src="https://randomuser.me/api/portraits/men/85.jpg"></v-img> -->
          <!-- <v-img src="https://randomuser.me/api/portraits/women/81.jpg"></v-img> -->
          <v-img src="/img/ubisell-logo-round.png"></v-img>
        </v-list-item-avatar>
        <!-- <v-list-item-title>Ubisell</v-list-item-title> -->
        <v-list-item-content>
          <v-list-item-title>{{fullname || 'Ubisell'}}</v-list-item-title>
          <v-list-item-subtitle v-if="user" class="text-caption text-decoration-underline cursor-pointer" @click="onLogout">Logout</v-list-item-subtitle>
          <v-list-item-subtitle v-if="!user" class="text-caption text-decoration-underline cursor-pointer" @click="onLogin">Login</v-list-item-subtitle>
        </v-list-item-content>
        <v-btn icon @click.stop="mini = !mini">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
      </v-list-item>
      <v-list-item v-if="sceltaMagazzini && !mini" dense class="mt-5 mb-3">
        <v-combobox
          dense
          hide-details
          label="Magazzino selezionato"
          :items="magazzini"
          item-value="codice"
          item-text="descrizione"
          :value="magazzinoSelezionato"
          :return-object="true"
          @change="onChangeMagazzino"
        >
          <template v-slot:append-outer>
            <v-icon color="info" @click="onAddEvent">mdi-playlist-plus</v-icon>
          </template>
        </v-combobox>
      </v-list-item>
      <v-divider></v-divider>
      <v-list dense nav>
        <template v-for="([group, icon, text, href], index) in licensedLinks">
          <v-list-group
            v-if="group && group.startsWith('*')"
            :key="index"
            no-action
            :prepend-icon="icon"
            :title="text"
            @click="toggleGruppo"
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>{{text}}</v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item
              v-for="([, icon, text, href], index) in licensedLinksGroup(group)"
              :to="href"
              :key="index"
              :title="text"
              link
            >
              <v-list-item-icon v-if="icon" class="icon-group">
                <v-icon :title="text">{{ icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ text }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
          <v-list-item
            v-else
            :to="href"
            :key="index"
            :title="text"
            link
          >
            <v-list-item-icon>
              <v-icon :title="text">{{ icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>
    <!-- <watson-assistant v-if="abilitaWatson"/> -->
    <dialog-magazzini :show="showMagazzini" @change="aggiornaMagazzini"/>
  </div>
</template>

<script>
/* import watsonAssistant from './watson/watsonAssistant_1' */
import DialogMagazzini from './magazzini/dialogMagazzini';
// import { elencoMenuConfigurazione }  from '../configurazione/menuDrawer.js'

export default {
  components: {
    /* watsonAssistant, */
    DialogMagazzini
  },
/*   mixins: [
    menuDrawer
  ], */
  data: (sm) => ({
    links: [
      ['', 'mdi-home-outline', 'Home', '/'],
      ['', 'mdi-archive-outline', sm.t('menu.articoli', 'Articoli'), '/v-articoli'],
      ['*ScalaTaglie', 'mdi-abacus', 'Scala Taglie', '', 'custom_scala_taglie'],
      ['ScalaTaglie', 'mdi-abacus', 'Operazioni', '/v-custom-scala-taglie/prodotti', 'custom_scala_taglie'],
      ['ScalaTaglie', 'mdi-cog-outline', 'Impostazioni', '/v-custom-scala-taglie', 'custom_scala_taglie'],
      ['', 'mdi-account-outline', sm.t('menu.clienti', 'Clienti e fornitori'), '/v-clienti'],
      ['', 'mdi-book-outline', sm.t('menu.movimenti', 'Movimenti'), '/v-movimenti'],
      ['*Documenti', 'mdi-file-document-edit-outline', 'Documenti', '', 'fatture'],
      ['Documenti', 'mdi-file-document-edit-outline', sm.t('menu.documenti', 'Documenti e Fatture'), '/v-documenti', 'fatture'],
      ['Documenti', 'mdi-account-details-outline', sm.t('menu.ordiniCliente','Ordini cliente'), '/v-ordini-cliente', 'ordini'],
      ['Documenti', 'mdi-clipboard-account-outline', sm.t('menu.ordiniFornitore','Documenti fornitore'), '/v-ordini-fornitore', 'ordini'],
      ['Documenti', 'mdi-file-arrow-up-down-outline', 'Autofatture', '/v-autofatture','fatturazioneElettronica'],
      ['Documenti', 'mdi-invoice-list-outline', 'Prima nota NF', '/v-primanota', 'contabilita'],
      ['*Import/Export', 'mdi-database-eye-outline', 'Import/Export', ''],
      ['Import/Export', 'mdi-archive-plus-outline', sm.t('menu.importArticoli','Import Articoli'), '/v-import'],
      ['Import/Export', 'mdi-database-import-outline', sm.t('menu.importGenerico','Import Generico'), '/v-import-generico'],
      ['Import/Export', 'mdi-database-export-outline', sm.t('menu.exportDati','Export dati'), '/v-export-dati'],
      ['Import/Export', 'mdi-database-import-outline', sm.t('menu.importDati','Import dati'), '/v-import-dati'],
      ['', 'mdi-printer-outline', 'Stampe', '/v-stampe'],
      ['', 'mdi-store-edit-outline', 'Inventario', '/v-inventario', 'inventario'],
      ['', 'mdi-parking', 'Park', '/v-park'],
      ['*Fatturazione', 'mdi-receipt-text-outline', 'Fatt. Elettronica', '','fatturazioneElettronica'],
      ['Fatturazione', 'mdi-folder-upload-outline', 'Fatture Emesse', '/v-fe-emesse','fatturazioneElettronica'],
      ['Fatturazione', 'mdi-folder-download-outline', 'Fatture Ricevute', '/v-fe-ricevute','fatturazioneElettronica'],

      ['*Controllo di gestione', 'mdi-account-cash-outline', 'Controllo di gestione', '','controlloGestione'],
      ['Controllo di gestione', 'mdi-cash-plus', 'Flussi in ingresso', '/gestione/v-cg-ingresso','controlloGestione'],
      ['Controllo di gestione', 'mdi-cash-minus', 'Flussi in uscita', '/gestione/v-cg-uscita','controlloGestione'],
      ['Controllo di gestione', 'mdi-account-multiple-outline', 'Personale', '/gestione/v-cg-personale','controlloGestione'],      
      ['Controllo di gestione', 'mdi-cash-check', 'Situazione', '/gestione/v-cg-situazione','controlloGestione'],
      ['Controllo di gestione', 'mdi-cash-sync', 'Analisi', '/gestione/v-cg-analisi','controlloGestione'],


      ['', 'mdi-cart-outline', 'Gestione eCommerce', '/v-ecommerce', 'eCommerce'],
      ['', 'mdi-clipboard-text-outline', 'Gestione lotti', '/v-lotti', 'lotti'],
      ['', 'mdi-family-tree', 'Distinta base', '/v-distinta-base', 'distintaBase'],
      ['*Ristorazione', 'mdi-silverware', 'Ristorazione', '', 'ristorazione_menu,totem'],
      ['Ristorazione', 'mdi-file-document-multiple-outline', 'Menù composti', '/ristorazione/menu-composti', 'ristorazione_menu,totem'],
      ['Ristorazione', 'mdi-movie-cog-outline', 'Variazioni', '/ristorazione/variazioni', 'ristorazione_menu,totem'],
      ['Ristorazione', 'mdi-cellphone-cog', 'Totem', '/ristorazione/totem', 'totem'],
      ['Ristorazione', 'mdi-format-list-bulleted', 'Ordina Tag Prodotti', '/ristorazione/alberatura-tag', 'ristorazione_menu'],
      // ['Menu', 'mdi-order-bool-descending', 'Ordina prodotti', '/ristorazione/ordina-prodotti-totem', 'ristorazione_menu'],

/*       ['*Totem', 'mdi-cellphone-cog', 'Totem', '', 'totem'],
      ['Totem', 'mdi-file-document-multiple-outline', 'Menù composti', '/ristorazione/menu-composti', 'totem'],
      ['Totem', 'mdi-movie-cog-outline', 'Variazioni', '/ristorazione/variazioni', 'totem'],
      ['Totem', 'mdi-cellphone-cog', 'Opzioni totem', '/ristorazione/totem', 'totem'],
      ['Totem', 'mdi-order-bool-descending', 'Ordina prodotti', '/ristorazione/ordina-prodotti-totem', 'totem'], */


      ['*Moduli', 'mdi-view-module-outline', 'Moduli custom', ''],
      ['Moduli', 'mdi-database-settings-outline', 'Benetton', '/v-custom-benetton', 'custom_benetton'],
      ['Moduli', 'mdi-eye-settings-outline', 'Ottici', '/v-custom-ottici', 'custom_ottici'],
      ['Moduli', 'mdi-clipboard-list-outline', sm.t('menu.listiniEsterni', 'Listini Esterni'), '/v-custom-esterni', 'custom_file_esterni'],
      ['Moduli', 'mdi-smoke', sm.t('menu.tabacchi', 'Tabacchi'), '/v-custom-tabacchi', 'custom_tabacchi'],
      ['Moduli', 'mdi-abacus', 'Scala Taglie', '/v-custom-scala-taglie', 'custom_scala_taglie'],
      ['Moduli', 'mdi-sale-outline', 'Gestione Offerte', '/v-custom-offerte', 'custom_offerte'],
      ['Moduli', 'mdi-scale-balance', 'Gestione Bilance', '/v-custom-bilance', 'custom_bilance'],
      ['', 'mdi-cellphone-settings', 'Mobile Platform', '/v-mobile-platform', 'mobile_platform'],
      ['', 'mdi-cog-outline', 'Configurazione', '/v-configurazione', null, 'administrator']
/*       ['Configurazioni', 'mdi-file-document-edit-outline', 'Reparti Fiscali', '/v-configurazione-reparti-fiscali', null, 'administrator'],
      ['Configurazioni', 'mdi-file-document-edit-outline', 'Aliquote Iva', '/v-configurazione-aliquote-iva', null, 'administrator'] */
    /*   ['mdi-chart-bar-stacked', 'Statistiche', ''], */
     /*  ['mdi-cog-outline', 'Configurazione', '/v-configurazione'] */
    ],
    show: true,
    mini: true,
    sceltaMagazzini: true, // TODO: da impostazioni,
    magazzini: [],
    magazzinoSelezionato: null,
    showMagazzini: false,
    abilitaWatson: false
  }),
  watch: {
    showDrawer(value) {
      if (value) {
        this.show = true
      }
    }
  },
  computed: {
    showDrawer() {
      return this.$store.getters.leftDrawer
    },
    user() {
      return this.$store.getters['utenti/user']
    },
    fullname() {
      return this.user ? `${this.user.first_name} ${this.user.last_name}` : ''
    },
    moduliLicenza() {
      return this.$store.getters.moduliLicenza
      // TODO: Verificare
      // return this.$store.getters.localModuliLicenza
    },
    licensedLinks() {
      const userIsAdmin = this.$store.getters['utenti/isAdministrator']
      const links = this.links.filter(x => {
        // return (!x[4] || this.moduliLicenza.includes(x[4])) && (!x[5] || userIsAdmin)
        const licOk = x[4] && _.intersection(this.moduliLicenza, x[4].split(','))
        return (!x[4] || licOk.length > 0) && (!x[5] || userIsAdmin)
      })
      return links.filter(x => !x[0] || x[0].startsWith('*')) // ritorno solo se non hanno gruppo o la testata del gruppo
    }
  },
  async mounted() {
    // TODO: Scelta magazzini deve essere legato anche alla licenza --> modulo specifico !!!
    this.sceltaMagazzini = await this.$store.dispatch('magazzini/usaMagazziniMultipli')
    if (this.sceltaMagazzini) { // TODO: Probabilmente viene da qualche impostazione --> non può essere sul mounted
      await this.aggiornaMagazzini()
    }
/*     const elencoMenu = elencoMenuConfigurazione()
    this.links = this.links.concat(elencoMenu) */
  },
  methods: {
    toggleGruppo() { // Se seleziono un gruppo, apro il drawer per far vedere il contenuto
      this.mini = false
    },
    async aggiornaMagazzini() {
      const magazzini = await this.$store.dispatch('magazzini/getElencoMagazzini', true)
      this.magazzini = magazzini.filter(x => !x.temporaneo && x.attivo) // TODO: Eventuali filtri e ordinamenti
      this.magazzinoSelezionato = await this.$store.dispatch('magazzini/getMagazzino')
    },
    t(codice, defaultValue) {
      const value = this.$vuetify.lang.t(`$vuetify.${codice}`)
      return value === `$vuetify.${codice}` ? defaultValue || '' : value || defaultValue
    },
    onLogout() {
      this.$store.commit('utenti/logout')
      this.$store.commit('CLEAR_MODULI_LICENZA')
      if (this.$route.name !== 'Home') {
        this.$router.push('/')
      }
      this.mini = false
    },
    onLogin() {
      this.$router.push('/login')
    },
    transitionend() {
      this.$store.commit('SET_LEFT_DRAWER', false)
    },
    onUpdate(event) {
      // Lascia chiuso il drawer
      this.mini = !this.mini
    },
    licensedLinksGroup(group) {
      const gp = group.slice(1)
      const userIsAdmin = this.$store.getters['utenti/isAdministrator']
      // const licensedLinks = this.links.filter(x => (!x[4] || this.moduliLicenza.includes(x[4])) && (!x[5] || userIsAdmin))
      const licensedLinks = this.links.filter(x => (!x[4] || (_.intersection(this.moduliLicenza, x[4].split(','))).length > 0) && (!x[5] || userIsAdmin))
      return licensedLinks.filter(x => x[0] === gp)
    },
    onChangeMagazzino(item) {
      console.log(item)
      this.magazzinoSelezionato = item.descrizione
      this.$store.commit('magazzini/SET_MAGAZZINO', item)
/*       if (item) {
        this.$emit('change', { model: this.item.model, subModel: this.item.subModel, value: item })
        this.oldValue = item.descrizione
      } else if (descrizione && descrizione.length > 0 && !this.item.addForbidden) {
        this.addElement(descrizione)
      } */
    },
    async onAddEvent() {
      this.showMagazzini = true
      await this.$nextTick()
      this.showMagazzini = false
    }
    /* ,
    toggleRight() {
      // solo per debug poi togliere
      this.$store.commit('SET_RIGHT_DRAWER', true)
    } */
  }
}
</script>

<style scoped>
  .icon-group:first-child {
    margin-right: 10px !important;
  }

  .cursor-pointer {
    cursor: pointer;
  }
</style>
